import React from 'react'
import CalendarSvg from 'images/modules/Manage/i-calendar-default.svg?raw'

export { default as CalendarUrl } from 'images/modules/Manage/i-calendar-default.svg'

export default props => (
  <span {...props} dangerouslySetInnerHTML={{__html: CalendarSvg}} />
)
